import {MsgType} from "@/utils/MsgType";
import StringUtils from "@/utils/StringUtils";

/**
 * 获取完整数据包 包含帧头帧尾
 * @param msgType
 * @param msg
 * @returns {Uint8Array}
 */
function getFullCmdBuffer(msgType, msg) {
  let cmd = [0xe7, 0xcc, 0x01, 0xed];
  let msgLenArr = new Uint8Array(new Uint16Array([msg.length]).buffer);
  console.log(`msg length = ` + msgLenArr)
  cmd.splice(2, 0, msgType);
  cmd.splice(3, 0, ...Array.from(msgLenArr));
  cmd.splice(5, 0, ...msg);
  return new Uint8Array(cmd);
}

/**
 * 获取设置基站为 IDLE 模式
 * @param imei
 * @param address
 * @returns {Uint8Array}
 */
function getSetIDLEMode(address){
  let addressArr = new Uint8Array(new Uint32Array([address]).buffer);
  return getFullCmdBuffer(MsgType.WEB_MSG_SET_IDLE_MODE,addressArr);
}
function getSetPlayMode(address){
  let addressArr = new Uint8Array(new Uint32Array([address]).buffer);
  return getFullCmdBuffer(MsgType.WEB_MSG_SET_PLAY_MODE,addressArr);
}

/**
 * 设置边缘服务器的区域信息
 * @param area
 * @param offsetX
 * @param offsetY
 * @param f0
 * @param f1
 * @returns {Uint8Array}
 */
function getSetSysAreaCmd(area,offsetX,offsetY,f0,f1) {
  let fullArr = [];
  let areaArr = new Uint8Array(StringUtils.hex2Bytes(area));
  let offsetXArr = new Uint8Array(new Float32Array([offsetX]).buffer)
  let offsetYArr = new Uint8Array(new Float32Array([offsetY]).buffer)
  let f0Arr = new Uint8Array(new Uint16Array([f0]).buffer);
  let f1Arr = new Uint8Array(new Uint16Array([f1]).buffer);
  fullArr.push(...Array.from(areaArr),...Array.from(offsetXArr),...Array.from(offsetYArr), ...Array.from(f0Arr), ...Array.from(f1Arr));
  return  getFullCmdBuffer(MsgType.WEB_MSG_SET_AREA, fullArr);

}
/**
 * 设置基站坐标
 * @returns {Uint8Array}
 */
function getSetAxisCmd(stationInfos) {
  let fullArr = [];
  for (let i = 0; i < stationInfos.length; i++) {
    let aid = new Uint8Array(new Uint32Array([stationInfos[i].aid]).buffer);
    let address = new Uint8Array(new Uint32Array([stationInfos[i].address]).buffer);
    let coords = new Uint8Array(new Float32Array(stationInfos[i].coords).buffer);
    fullArr.push(...Array.from(aid),...Array.from(address), ...Array.from(coords));
  }
  return getFullCmdBuffer(MsgType.WEB_MSG_SET_EDGE_AXIS, fullArr);
}

/**
 * 设置基站参数
 * @returns {Uint8Array}
 */
function getSetSysParamCmd(address,playFileIndex,leftVol,rightVol,syncDelay,loraNetAddress,deviceAddress,channel) {

  let param = [];
  let addressArr = Array.from(new Uint8Array(new Uint32Array([address]).buffer));
  let fileIndexArr = Array.from(new Uint8Array([playFileIndex])) ;
  let leftVolArr = Array.from(new Uint8Array([leftVol]));
  let rightVolArr = Array.from(new Uint8Array([rightVol]));
  let syncDelayArr = Array.from(new Uint8Array(new Uint16Array([syncDelay]).buffer));
  let netAddressIntArr = [];
  for (let i = 0; i <loraNetAddress.length ; i+=2) {
    netAddressIntArr.push(parseInt(loraNetAddress.slice(i,i+2),16))
  }
  let netAddrArr = Array.from(new Uint8Array(netAddressIntArr));
  let deviceAddrArr = Array.from( new Uint8Array([deviceAddress]));
  let channelArr = Array.from(new Uint8Array([channel]));
  param.push(...addressArr,...fileIndexArr,...leftVolArr,...rightVolArr,...syncDelayArr,...netAddrArr,...deviceAddrArr,...channelArr);
  return getFullCmdBuffer(MsgType.WEB_MSG_SET_SYS_PARAM,param);

}

/**
 * 获取边缘服务器坐标的参数
 * @returns {Uint8Array}
 */
function getEdgeAxisCmd() {
  return getFullCmdBuffer(MsgType.WEB_MSG_GET_EDGE_AXIS,[]);
}

/**
 * 获取边缘服务器的区域信息，每个区域对应一组音频频率
 * @returns {Uint8Array}
 */
function getEdgeAreaCmd() {
  return getFullCmdBuffer(MsgType.WEB_MSG_GET_AREA,[]);
}

/**
 * 读取基站参数
 * @param address
 * @returns {Uint8Array}
 */
function getSysParamCmd(address) {
  let addressArr = new Uint8Array(new Uint32Array([address]).buffer);
  return getFullCmdBuffer(MsgType.WEB_MSG_GET_SYS_PARAM,addressArr);
}

/**
 * 解析坐标
 * @param imei
 * @param message
 * @param onData
 */
function parsePos(imei,message,onData){
  let labelId = StringUtils.bytes2Hex(message.slice(0,4).reverse());
  let addrEdge = StringUtils.bytes2Hex( message.slice(4,8).reverse());
  let x = new Float32Array(new Uint8Array([message[8],message[9],message[10],message[11]]).buffer)[0];
  let y = new Float32Array(new Uint8Array([message[12],message[13],message[14],message[15]]).buffer)[0];
  let z = new Float32Array(new Uint8Array([message[16],message[17],message[18],message[19]]).buffer)[0];
  onData(imei,MsgType.WEB_MSG_SEND_POS,{labelId,addrEdge,x,y,z});
}

/**
 * 解析边缘服务器坐标的参数
 * @param imei
 * @param message
 * @param onData
 */
function parseEdgeAxis(imei,message,onData){
  let stationLen = message.length/20;
  let edgeAxis = [];
  for (let i = 0; i < stationLen; i++) {
    let aid = new Uint32Array(new Uint8Array(message.slice(0 + 20*i,4 + 20*i)).buffer)[0];
    let address = new Uint32Array(new Uint8Array(message.slice(4 + 20*i,8 + 20*i)).buffer)[0];
    let x = new Float32Array(new Uint8Array(message.slice(8 + 20*i,12 + 20*i)).buffer)[0].toFixed(2);
    let y = new Float32Array(new Uint8Array(message.slice(12 + 20*i,16 + 20*i)).buffer)[0].toFixed(2);
    let z = new Float32Array(new Uint8Array(message.slice(16 + 20*i,20 + 20*i)).buffer)[0].toFixed(2);
    console.log(` aid = ${aid} address = ${address} x = ${x} y = ${y} z = ${z}`);

    edgeAxis.push({
      aid:aid,
      address:address,
      coords:[parseFloat(x),parseFloat(y),parseFloat(z)]
    });
  }
  onData(imei,MsgType.WEB_MSG_GET_EDGE_AXIS,edgeAxis);
}

/**
 * 解析边缘服务器的区域信息
 * @param imei
 * @param message
 * @param onData
 */
function parseEdgeArea(imei,message,onData){

  let addrEdge = StringUtils.bytes2Hex(message.slice(0,4).reverse());
  let offsetX = new Float32Array(new Uint8Array(message.slice(4,8)).buffer)[0].toFixed(2);
  let offsetY = new Float32Array(new Uint8Array(message.slice(8,12)).buffer)[0].toFixed(2);
  let f0 = new Uint16Array(new Uint8Array(message.slice(12,14)).buffer)[0];
  let f1 = new Uint16Array(new Uint8Array(message.slice(14,16)).buffer)[0];
  onData(imei,MsgType.WEB_MSG_GET_AREA,{addrEdge,offsetX,offsetY,f0,f1});
  console.log(` addrEdge = ${addrEdge} f0 = ${f0} f1 = ${f1} offsetX = ${offsetX} offsetY = ${offsetY}`);
}


function handleMqttMessage(imei,msg,onData,onFailed) {
  console.log(typeof imei)
  console.log(typeof msg)
  console.log(msg)
  console.log(typeof onData)
  if (msg[0] === 0xE7 && msg[1] === 0xCC) {
    let msgType = msg[2];
    let respType = msg[3];
    let msgLen = new Uint16Array([msg[4],msg[5]])[0];
    let message = [];
    if (msgLen !== 0) {
      message = msg.slice(6,msg.length-2);
    }
    console.log(msgType,respType);
    if (msgType === MsgType.WEB_MSG_OK) {//发送成功
      switch (respType) {
        case MsgType.WEB_MSG_SET_AREA: //设置边缘服务器的区域信息，每个区域对应一组音频频率
          console.log("add edge success");
          onData(imei,MsgType.WEB_MSG_SET_AREA);
          break;
        case MsgType.WEB_MSG_SET_EDGE_AXIS: //设置边缘服务器坐标的参数
          console.log("add station success")
          onData(imei,MsgType.WEB_MSG_SET_EDGE_AXIS);
          break;
        case MsgType.WEB_MSG_GET_SYS_PARAM: //获取系统设置参数

            let address = new Uint32Array(message.slice(0,4))[0];
            let playFileIndex = new Uint8Array([message[4]])[0];
            let leftVol = new Uint8Array([message[5]])[0];
            let rightVol = new Uint8Array([message[6]])[0];
            let syncDelay = new Uint16Array(new Uint8Array([message[7],message[8]]).buffer)[0];
            let loraNetAddress = StringUtils.bytes2Hex(message.slice(9,13).reverse());// message[12].toString(16) + message[11].toString(16) + message[10].toString(16) + message[9].toString(16);
            let deviceAddress = new Uint8Array([message[13]])[0];
            let channel = new Uint8Array([message[14]])[0];
            onData(imei,MsgType.WEB_MSG_GET_SYS_PARAM,
              {address,playFileIndex,leftVol,rightVol,syncDelay,loraNetAddress,deviceAddress,channel});
          break;
        case MsgType.WEB_MSG_SET_SYS_PARAM:
          console.log("set system param success");
          onData(imei,MsgType.WEB_MSG_SET_SYS_PARAM);
          break;
        case MsgType.WEB_MSG_SEND_POS:
          parsePos(imei,message,onData);
          break;
        case MsgType.WEB_MSG_GET_EDGE_AXIS:
          parseEdgeAxis(imei,message,onData);
          break;
        case MsgType.WEB_MSG_GET_AREA:
          parseEdgeArea(imei,message,onData);
          break;
        case MsgType.WEB_MSG_SET_IDLE_MODE:
          onData(imei,MsgType.WEB_MSG_SET_IDLE_MODE);
          break
        case MsgType.WEB_MSG_SET_PLAY_MODE:
          onData(imei,MsgType.WEB_MSG_SET_PLAY_MODE);
          break
      }

    }else if (msgType === MsgType.WEB_MSG_FAILED){ //发送失败
      onFailed();
    }

  }
}
export default {
  handleMqttMessage,getSetIDLEMode,getSetPlayMode,
  getSetSysParamCmd,getSetAxisCmd,getEdgeAxisCmd,
  getEdgeAreaCmd,getSysParamCmd,getSetSysAreaCmd
}
